import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import { RowView, RowView2 } from "../../../../Component/style/common_style";
import { amountFormat } from "../../../../Component/tool/Tools";
import api from "../../../../Component/axios_Interceptor/api";
import { useEffect, useState } from "react";
import url from "../../../../Component/server";

interface CompleteModalProps extends modalProps {
  chargeCoin: number;
  myCoin: number;
  handleCharge?: () => void;
  handleCheck?: () => void;
}

interface UserInfoProps {
  name: string;
}

const CompleteModal = ({
  visible,
  handleModal,
  chargeCoin,
  myCoin,
  handleCharge,
  handleCheck,
}: CompleteModalProps) => {
  const closeModal = () => {
    handleModal();
    handleCheck && handleCheck();
    handleCharge && handleCharge();
  };
  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const [userInfo, setUserInfo] = useState<UserInfoProps>({
    name: "",
  });

  const get_user_info = async () => {
    const res = await api.get(url.Communication_url.user_info);
    setUserInfo(res.data);
  };

  useEffect(() => {
    get_user_info();
  }, []);

  return (
    <Container
      style={visible ? {} : { display: "none" }}
      onClick={stopPropagation}
    >
      <ModalBox>
        <Title>입금 정보</Title>
        <ContentDiv>
          <div className="medium">무통장 입금</div>
          <div>아래 계좌에 입금 완료 시 포인트가 충전됩니다.</div>
        </ContentDiv>
        <RowView2 style={{ marginBottom: 30 }}>
          <InfoDiv>
            <div>입금은행/예금주</div>
            <div>입금계좌</div>
            <div>입금대기금액</div>
            <div>입금자명</div>
          </InfoDiv>
          <InfoDiv>
            <div className="bankInfo">광주은행 / 이헌영(링크캠퍼스)</div>
            <div className="bankInfo">1121-024-896929</div>
            <div className="bankInfo">
              {amountFormat(chargeCoin * 100)}원
              <div className="gray">({amountFormat(chargeCoin)}C)</div>
            </div>
            <div className="bankInfo">{userInfo.name}</div>
          </InfoDiv>
        </RowView2>
        <BtnDiv>
          <ApplyBtn onClick={closeModal}>확인</ApplyBtn>
        </BtnDiv>
      </ModalBox>
    </Container>
  );
};
export default CompleteModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 50rem;
  margin: auto 0rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  padding: 34px 24px;
  div.info {
    color: #8e8e8e;
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const SubTitle = styled.div`
  font-size: 18px;
  font-family: var(--font-Pretendard-SemiBold);
  margin-bottom: 24px;
`;

const ContentDiv = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: var(--font-Pretendard-Regular);
  flex-direction: column;
  text-align: center;
  color: #8e8e8e;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  margin: 30px 0px;
  gap: 8px;
  .medium {
    font-family: var(--font-Pretendard-Medium);
    color: black;
    font-size: 16px;
  }
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
`;

const Btn = styled.div`
  border-radius: 8px;
  padding: 14px 30px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
  cursor: pointer;
`;

const CancelBtn = styled(Btn)`
  margin-right: 5px;
  background-color: #f8f8f8;
  color: #8e8e8e;
`;

const ApplyBtn = styled(Btn)`
  margin-left: 5px;
  background: linear-gradient(135deg, #7955f0, #3209b9);
  color: white;
`;

const InfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 130px;
  color: #8e8e8e;
  .bankInfo {
    width: 300px;
    font-family: var(--font-Pretendard-Medium);
    font-size: 16px;
    color: black;
    flex-direction: row;
    display: flex;

    .gray {
      color: #8e8e8e;
    }
  }
`;
